import { Icon } from "@iconify/react";
import { Form, Input, Modal, Select, Space } from "antd";

// eslint-disable-next-line react/prop-types
export default function DocumentAnalysisResponsiveFilter({ form, responsiveFilter,  setResponsiveFilter,  setKeyword, keyword, districts = [], villages = [], cities = [], district, city, marketing, handleChangeMarketingQuery }){
  return (
    <Modal
      open={responsiveFilter}
      title="Filter"
      centered
      onCancel={() => setResponsiveFilter(false)}
      onOk={() => setResponsiveFilter(false)}
    >
      <Form form={form} >
        <Space size={'large'} direction="vertical" style={{ width: '100%', margin: '20px 0' }} >
          <Input 
            prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
            placeholder="cari.."
            onChange={e => setKeyword(e.target.value)}
            value={keyword}
            allowClear
          />
          <Input
            prefix={<Icon icon="solar:user-rounded-linear" width="16" height="16" />}
            placeholder="Marketing"
            onChange={e => handleChangeMarketingQuery(e.target.value)}
            value={marketing}
            allowClear
          />
          <Form.Item noStyle name={'city'} >
            <Select
              allowClear
              options={cities?.map(e => ({ label: e.name, value: e.name }))}
              style={{ width: '100%' }}
              placeholder="Kota"
            />
          </Form.Item>
          <Form.Item noStyle name={'district'} >
            <Select
              allowClear
              options={districts?.map(e => ({ label: e.name, value: e.name }))}
              style={{ width: '100%' }}
              placeholder="Kecamatan"
              disabled={!city}
            />
          </Form.Item>
          <Form.Item name={'village'} noStyle >
            <Select
              allowClear
              options={villages?.map(e => ({ label: e.name, value: e.name }))}
              style={{ width: '100%' }}
              placeholder="Kelurahan"
              disabled={!district}
            />
          </Form.Item>
        </Space>
      </Form>
    </Modal> 
  )
}